import { getFeature, isFeature } from 'Cloud/Application/FeaturesEs6';

export enum PersonalizationQuota {
    W256GB = 256,
    W512GB = 512,
    W1TB = 1024,
    W2TB = 2048,
    W4TB = 4096,
}

export enum PersonalizationPeriod {
    Month = 'month',
    Year = 'year',
}

type TariffMap = Record<PersonalizationQuota, string>;
type PeriodTariffMap = Record<PersonalizationPeriod, TariffMap>;

const DEFAULT_MINIMAL_TARIFFS: PeriodTariffMap = {
    [PersonalizationPeriod.Month]: {
        [PersonalizationQuota.W256GB]: 'W256GB_1m_minimal_force_trial_2026',
        [PersonalizationQuota.W512GB]: 'W512GB_1m_minimal_force_trial_2026',
        [PersonalizationQuota.W1TB]: 'W1TB_1m_minimal_force_trial_2026',
        [PersonalizationQuota.W2TB]: 'W2TB_1m_minimal_force_trial_2026',
        [PersonalizationQuota.W4TB]: 'W4TB_1m_minimal_force_trial_2026',
    },
    [PersonalizationPeriod.Year]: {
        [PersonalizationQuota.W256GB]: 'W256GB_1y_minimal_force_trial_2026',
        [PersonalizationQuota.W512GB]: 'W512GB_1y_minimal_force_trial_2026',
        [PersonalizationQuota.W1TB]: 'W1TB_1y_minimal_force_trial_2026',
        [PersonalizationQuota.W2TB]: 'W2TB_1y_minimal_force_trial_2026',
        [PersonalizationQuota.W4TB]: 'W4TB_1y_minimal_force_trial_2026',
    },
};

const DEFAULT_BUSINESS_TARIFFS: PeriodTariffMap = {
    [PersonalizationPeriod.Month]: {
        [PersonalizationQuota.W256GB]: 'W256GB_1m_business_force_trial_2026',
        [PersonalizationQuota.W512GB]: 'W512GB_1m_business_force_trial_2026',
        [PersonalizationQuota.W1TB]: 'W1TB_1m_business_force_trial_2026',
        [PersonalizationQuota.W2TB]: 'W2TB_1m_business_force_trial_2026',
        [PersonalizationQuota.W4TB]: 'W4TB_1m_business_force_trial_2026',
    },
    [PersonalizationPeriod.Year]: {
        [PersonalizationQuota.W256GB]: 'W256GB_1y_business_force_trial_2026',
        [PersonalizationQuota.W512GB]: 'W512GB_1y_business_force_trial_2026',
        [PersonalizationQuota.W1TB]: 'W1TB_1y_business_force_trial_2026',
        [PersonalizationQuota.W2TB]: 'W2TB_1y_business_force_trial_2026',
        [PersonalizationQuota.W4TB]: 'W4TB_1y_business_force_trial_2026',
    },
};

export const personalizedSidebarBannerEnabled = isFeature('personalized-sidebar-banner-enabled');
export const personalizationMinimalTariffs: PeriodTariffMap = getFeature('personalization-minimal-tariffs') || DEFAULT_MINIMAL_TARIFFS;

export const personalizationBusinessTariffs: PeriodTariffMap = getFeature('personalization-business-tariffs') || DEFAULT_BUSINESS_TARIFFS;
export const personalizedTopBannerEnabled = isFeature('personalized-top-banner-enabled');
